<template>
    <div>
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>学生管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 图片视图 -->
    <el-card>
      
    <!-- 搜索区域 -->

      <div>


        <el-row>
          <el-col :span="2">
            <el-input placeholder="姓名" v-model="names" > </el-input>
        </el-col>
        <el-col :span="2">
            <!-- <el-input placeholder="年级" v-model="classgrade" > </el-input> -->
            <el-select v-model="classgrade" placeholder="班级">
      <el-option label="全部班级" value="" ></el-option>
      <el-option :label="info.className" :value="info.className" v-for="(info,index) in classList" :key="index"></el-option>
    </el-select>
        </el-col>
        <el-col :span="4">
            <el-input placeholder="手机号" v-model="mobile" > </el-input>
        </el-col>
        <el-col :span="3"> <el-button  @click="searUser" @keyup.enter.native="searUser">搜索</el-button></el-col>
       
      </el-row>
    </div>
      <el-table
        :data="userlist"
         border
        show-overflow-tooltip="true"
        tooltip-effect="dark"
         ref="multipleTable"
        style="width: 100%"
         @selection-change="handleSelectionChange">
        <el-table-column
          type="selection" 
          width="40"
           >
        </el-table-column>

        <el-table-column
          prop="username"
          label="用户名"
          width="180">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="180">
        </el-table-column>
    
        <el-table-column
          prop="className"
          label="班级"
          width="120">
        </el-table-column>

        <el-table-column
          prop="mobiles"
          label="手机号码"
          width="180">
        </el-table-column>
        <el-table-column
          prop="type"
          label="用户权限"
          width="180"
          :formatter="stateFormat"
          >
        </el-table-column>


        <el-table-column
          prop="address"
          show-overflow-tooltip
          label="家庭住址"
          width="180">
        </el-table-column>

        <el-table-column
          prop="email"
          label="创建时间"
          width="180">
        </el-table-column>
        <el-table-column
          label="密码重置" 
          width="100">
          <!-- 卡槽 -->
          <template slot-scope="scope">
             <el-button  type="success"  @click="resetpassword(scope.row.userid)"  >重置</el-button>
    </template>
        </el-table-column>
   
            <el-table-column
          label="操作"
          width="150">
          <template slot-scope="scope">
    <el-button disabled  @click="updateNew(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
    <el-button  @click="deleteUser(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
          </template>
        </el-table-column>
      </el-table>
       <div style="margin-top: 20px">
        <el-button @click="selectDatas">导出Excel</el-button>
        <el-button @click="toggleSelection()">取消选择</el-button>
      </div>
    </el-card>
    <!-- 弹窗 -->
    
    

    </div>
    </template>
    
    <script>
     import VDistpicker from 'v-distpicker'
     import { checkMobiles, checkStudentID, checkUsername ,checkPassword} from '@/components/work/until/vaildate.js'
    export default {
       components: { VDistpicker },
      data(){
        var checkAge=(rule,value,callback) =>{
         let reg=/^(?:[1-9][0-9]?|1[01][0-9]|120)$/;//年龄是1-120之间有效
         if(!reg.test(value)){
            callback(new Error("年龄不合法"))
         }else{
          callback();
         }
        }
        var checkAddress=(rule,value,callback) =>{
         if(value===''|value===null){
          callback(new Error("请输入地址"))
         }else{
          callback();
         }
        }
        return{
    // {name: '', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}
            fileList:[{}],
             sendPower:false,
              multipleSelection: [],
              seraList:[],
              classList:'',
            time:'',
            input3: '',
            names:'',
            classgrade:'',
            mobile:'',
            userlist:[],
            news:{},
            insertNew:false,
            updateNews:false,
            old_newsUrl:'',
            userForm:{
              username:'',
              password:'',
              name:'',
              age:'',
              sex:'',
              address:'',
              type:'',
               mobiles:'',
              authCode:'',
               
            },
            userRules:{
              username:[
                {required:true,message:'请输入用户名',trigger:'blur'},
                {validator:checkUsername,trigger:'blur'}
                ],
              password:[
                 {required:true,message:'请输入密码',trigger:'blur'},
                 { validator:checkPassword , trigger: 'blur' }
              ],
               name:[
                {required:true,message:'请输入姓名',trigger:'blur'},
                {min:2,max:100,message:'姓名的长度在3~10个字符之间'}
                ],
              //  address:[
              //    {validator:checkAddress,trigger:'change'},
                
              // ],
                type:[
                {required:true,message:'选择用户类型',trigger:'change'},
                ],
                 mobiles:[
                 { required: true, message: '手机号', trigger: 'blur' },
                 {validator:checkMobiles, trigger: 'blur' }
              ],
              authCode:[
                { required: true, message: '请输入验证码', trigger: 'blur' },
                { min: 6, max: 6, message: '长度为6位数字', trigger: 'blur' }
              ],
            },
      }},
    created(){
      this.getUsers()
    },
    methods:{
      getUsers(){
        this.axios.post("/classGrade/getClassGrade")
              .then(res => { 
                          if(res.data.status == 1) {                                                       
                                        this.classList=res.data.result;                                                                         
                                    }else {
                                       alert("拿取数据失败")                                 
                                    }
                                })
                                .catch((err) => {
                                   // alert("出错了")
                                    console.log(err)
                                }) 
              this.axios.post("/user/getUser?type=1")
              .then(res => { 
                          if(res.data.status == 1) {                                                       
                                        this.infolist=res.data.result;
                                        this.userlist=res.data.result                                                                                  
                                    }else {
                                       alert("拿取数据失败")                                 
                                    }
                                })
                                .catch((err) => {
                                   // alert("出错了")
                                    console.log(err)
                                }) 
          },searUser(){
            if(this.seraList.length<=0){
            this.seraList=this.userlist
          }
          this.userlist=this.seraList.filter((item)=>{
              if(this.names!=''){
              return  this.names==item.name
           }else{
            return true
           }
            })
            this.userlist=this.userlist.filter((item)=>{
              if(this.mobile!=''){
              return  item.mobiles.includes(this.mobile)
           }else{
            return true
           }
            })
            this.userlist=this.userlist.filter((item)=>{
              if(this.classgrade!=''){
              return  this.classgrade==item.className
           }else{
            return true
           }
            })

          },resetpassword(data){
            const that=this
            this.$confirm("确定重置？","提示",{
              confirmButtonText: "确认",//确认按钮文字更换
              cancelButtonText: "取消",//取消按钮文字更换
              showClose: true,//是否显示右上角关闭按钮
              type: "warning",//提示类型  success/info/warning/error
          }).then(function(){  
            that.axios.post("/user/resetpassword?userid="+data)
            .then((resp) => {
              if (resp.data.status == 1) {
                that.$message.success("重置成功");
              } else {
                alert("拿取数据失败");
              }
            })
            .catch((err) => {
              that.$message.error("出错");
            })
          }).catch(()=>{});
          },       toggleSelection(rows) {
            if (rows) {
              rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
              });
            } else {
              this.$refs.multipleTable.clearSelection();
            }
          },selectDatas(){
            
          if(this.multipleSelection.length===0){
              this.$message.error("请选择导出列表")
              return
            }
          this.axios({
            url: "/user/exportExcel",   //后端地址
            method: "post",
            data:this.multipleSelection, //请求参数
            headers: {  
            'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
            },
            // contenType:'application/json',
            responseType: "blob"
          })
            .then(res => {
              var _this = this;
    　　let yy = new Date().getFullYear();
    　　let mm = new Date().getMonth()+1;
    　　let dd = new Date().getDate();
    　　let hh = new Date().getHours();
    　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    　　let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    　　_this.gettime = yy+''+mm+''+dd+''+hh+''+mf+''+ss;
    
              const blob = new Blob([res.data], { type: 'xlsx' });
              const fileName = "学生报表"+_this.gettime+".xlsx"; 
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink); 
                this.selectData=false
            })
            },  handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          onSelect: function(data) {
              this.citydata = data.province.value + data.city.value + data.area.value;
              this.userForm.address=this.citydata
              console.log(this.citydata);
              //alert(this.userForm.address)
            },
            stateFormat(row, column) {
        if (row.type === 1) {
          return '学生'
        }else if(row.type==5){
          return '辅导员'
        }else if(row.type==0){
          return '老师'
        } else  {
          return '领导'
        } 
      },
          deleteUser(data){
            const that=this
            this.$confirm("确定删除？","提示",{
              confirmButtonText: "确认",//确认按钮文字更换
              cancelButtonText: "取消",//取消按钮文字更换
              showClose: true,//是否显示右上角关闭按钮
              type: "warning",//提示类型  success/info/warning/error
          }).then(function(){  
            that.axios.post("/user/deleteUser?userid="+data.userid)
              .then(resp => { 
                          if(resp.data.status == 1) {    
                            that.$message.success("删除成功") 
                            that.getUsers()                                                                                                                                                                   
                                    }else {
                                       alert("删除失败")                                 
                                    }
                                })
                                .catch((err) => {
                                   alert("出错了")
                                    console.log(err)
                                }) 
          }).catch(()=>{});
          },
    
      
          
        } ,  }
    </script>
    
    <style scoped>
    .el-main{
      
        line-height: 0px;
    }
    
      .el-card{
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15) !important;
      }
      element.style {
        height:0px;
    }
    .icon {
      width: 1em;
      height: 1em;
      vertical-align: -0.15em;
      fill: currentColor;
      overflow: hidden;
    }
    </style>


// WEBPACK FOOTER //
// src/components/work/bam/viewStudentBam.vue